import { Button, Modal, ModalDialog, FormControl, FormLabel, Input, Stack, IconButton, Select, Option } from "@mui/joy";
import { DataGridPremium } from "@mui/x-data-grid-premium";
import React, { useEffect, useState } from "react";
import { getFetch, postFetch } from "../../../../../../fetch/fetch";
import { dateToDateString } from "../../../etc/etcfunctions";
import { Delete, Create } from "@mui/icons-material";
import totalLocationData from "../../../../../../data/locationdata";

const TravelAllowanceManagement: React.FC<any> = (props) => {

    const [rows, setRows] = useState<any[]>([]);
    const [loading, setLoading] = useState(false);
    const [update, setUpdate] = useState(0);

    // 금액 수정 모달 상태
    const [editModalOpen, setEditModalOpen] = useState(false);
    const [editTargetId, setEditTargetId] = useState<number | null>(null);
    const [editTargetTitle, setEditTargetTitle] = useState("");
    const [editValue, setEditValue] = useState("");
    const [editLoading, setEditLoading] = useState(false);

    const [columns, setColumns] = useState<any[]>([
        { field: "departureLocation", headerName: "출발 지점", width: 130 },
        { field: "arrivalLocation", headerName: "도착 지점", width: 130 },
        {
            field: "substituteAllowance", headerName: "출장비 금액", width: 150, renderCell: (params: any) => {

                return (
                    <div style={{
                        display: "flex",
                        alignItems: "center",
                    }}>
                        <span>
                            {(params.value ?? 0).toLocaleString()}원
                        </span>
                        <span style={{
                            cursor: "pointer",
                            marginLeft: "15px"
                        }}
                            onClick={() => {
                                setEditTargetId(params.row.id);
                                setEditTargetTitle(`${params.row.departureLocation} → ${params.row.arrivalLocation} 출장비 금액 수정(원)`);
                                setEditValue(String(params.value ?? ""));
                                setEditModalOpen(true);
                            }}
                        >
                            <Create
                                fontSize="small"
                                color="disabled"
                            />
                        </span>
                    </div>
                )
            }
        },
        { field: "updatedAt", headerName: "수정일", width: 150 },
        {
            field: "delete", headerName: "삭제", width: 100, renderCell: (params: any) => {

                const id = params.row.id;

                const deleteTravelAllowance = async () => {
                    try {
                        if (!id) {
                            return;
                        }

                        if (!window.confirm("정말로 출장비 경로를 삭제하시겠습니까?")) {
                            return;
                        }

                        const result: any = await postFetch("/dashboard/salary/deletetravelallowance", {
                            travelAllowanceId: id,
                        });

                        if (result.message === "success") {
                            props.notify("success", "출장비 경로가 성공적으로 삭제되었습니다.");
                            setUpdate(Math.random());
                        }

                    } catch (e) {
                        console.log(e);
                    }
                };

                return (
                    <div>
                        <IconButton
                            onClick={deleteTravelAllowance}
                        >
                            <Delete />
                        </IconButton>
                    </div>
                )
            }
        }
    ]);

    const [modalOpen, setModalOpen] = useState(false);

    // 출장비 추가 모달의 입력값 상태 (지점명은 한글로 저장)
    const [newTravelAllowance, setNewTravelAllowance] = useState({
        departureLocation: "",
        arrivalLocation: "",
        amount: "",
    });

    const [submitLoading, setSubmitLoading] = useState(false);

    useEffect(() => {

        setNewTravelAllowance({
            departureLocation: "",
            arrivalLocation: "",
            amount: "",
        });

    }, [modalOpen]);

    useEffect(() => {

        getTravelAllowances();

    }, [update]);

    const getTravelAllowances = async () => {

        try {

            setLoading(true);

            const result: any = await getFetch("/dashboard/salary/gettravelallowances");

            if (result.message === "success") {

                const newRows: any = [];

                result.data.forEach((item: any) => {
                    const oneRow: any = {};
                    oneRow.id = item.id;
                    oneRow.departureLocation = item.departureLocation;
                    oneRow.arrivalLocation = item.arrivalLocation;
                    oneRow.substituteAllowance = item.substituteAllowance;
                    oneRow.updatedAt = item.updatedAt ? dateToDateString(new Date(item.updatedAt)) : "";
                    newRows.push(oneRow);
                });

                setRows([...newRows]);
            }

            setLoading(false);

        } catch (e) {
            console.log(e);
            setLoading(false);
        }

    }

    const submitNewTravelAllowance = async (e: React.FormEvent) => {
        e.preventDefault();

        try {

            if (!newTravelAllowance.departureLocation || !newTravelAllowance.arrivalLocation || !newTravelAllowance.amount) {
                return;
            }

            if (newTravelAllowance.departureLocation === newTravelAllowance.arrivalLocation) {
                props.notify("error", "출발 지점과 도착 지점이 같을 수 없습니다.");
                return;
            }

            if (!(parseInt(newTravelAllowance.amount) > 0)) {
                props.notify("error", "출장비 금액은 0보다 커야 합니다.");
                return;
            }

            setSubmitLoading(true);

            const result: any = await postFetch("/dashboard/salary/addtravelallowance", {
                departureLocation: newTravelAllowance.departureLocation,
                arrivalLocation: newTravelAllowance.arrivalLocation,
                substituteAllowance: parseInt(newTravelAllowance.amount),
            });

            if (result.message === "success") {
                props.notify("success", "출장비 경로가 성공적으로 추가되었습니다.");
                setModalOpen(false);
                setUpdate(Math.random());
            } else {
                props.notify("error", result.message);
            }

            setSubmitLoading(false);

        } catch (e) {
            console.log(e);
            setSubmitLoading(false);
        }
    };

    const submitEditTravelAllowance = async () => {

        try {

            if (!editTargetId) {
                return;
            }

            if (!(parseInt(editValue) > 0)) {
                props.notify("error", "출장비 금액은 0보다 커야 합니다.");
                return;
            }

            setEditLoading(true);

            const result: any = await postFetch("/dashboard/salary/updatetravelallowance", {
                travelAllowanceId: editTargetId,
                substituteAllowance: parseInt(editValue),
            });

            if (result.message === "success") {
                props.notify("success", "출장비 금액이 수정되었습니다.");
                setEditModalOpen(false);
                setEditTargetId(null);
                setEditValue("");
                setUpdate(Math.random());
            } else {
                props.notify("error", result.message);
            }

            setEditLoading(false);

        } catch (e) {
            console.log(e);
            setEditLoading(false);
        }
    };

    // 지점 선택 옵션 (한글 지점명 — 운영진 소속 출장비 등록도 가능하도록 total 포함)
    const renderLocationOptions = () => {
        return totalLocationData.map((data: any, index: number) => {

            if (!data.academy.includes("sunbae") && !data.academy.includes("bundangsunbae")) {
                return null;
            }

            return (
                <Option key={index} value={data.korean}>
                    {data.korean}
                </Option>
            )

        });
    };

    return (
        <div>
            <div style={{
                marginTop: "30px",
                marginBottom: "15px",
                width: "700px",
                display: "flex",
                justifyContent: "flex-end",
            }}>
                <Button
                    variant="outlined"
                    onClick={() => setModalOpen(true)}
                >
                    출장비 추가
                </Button>
            </div>
            <div
                style={{
                    height: "600px",
                    width: "700px",
                }}
            >
                <DataGridPremium
                    rows={rows}
                    columns={columns}
                    loading={loading}
                    density="compact"
                    hideFooter={true}
                />
            </div>

            {/* 출장비 추가 모달 */}
            <Modal
                open={modalOpen}
                onClose={() => setModalOpen(false)}
            >
                <ModalDialog>
                    <form onSubmit={submitNewTravelAllowance}>
                        <Stack spacing={2}>
                            <div style={{ fontSize: "18px", fontWeight: 600 }}>
                                출장비 추가하기
                            </div>

                            <FormControl>
                                <FormLabel>출발 지점 (본인 소속 지점)</FormLabel>
                                <Select
                                    placeholder="출발 지점을 선택해주세요"
                                    value={newTravelAllowance.departureLocation}
                                    onChange={(e: any, newValue: any) => {
                                        setNewTravelAllowance((prev) => ({ ...prev, departureLocation: newValue ?? "" }));
                                    }}
                                    style={{ width: "280px" }}
                                >
                                    {renderLocationOptions()}
                                </Select>
                            </FormControl>

                            <FormControl>
                                <FormLabel>도착 지점 (근무 지점)</FormLabel>
                                <Select
                                    placeholder="도착 지점을 선택해주세요"
                                    value={newTravelAllowance.arrivalLocation}
                                    onChange={(e: any, newValue: any) => {
                                        setNewTravelAllowance((prev) => ({ ...prev, arrivalLocation: newValue ?? "" }));
                                    }}
                                    style={{ width: "280px" }}
                                >
                                    {renderLocationOptions()}
                                </Select>
                            </FormControl>

                            <FormControl>
                                <FormLabel>출장비 금액 (원)</FormLabel>
                                <Input
                                    type="number"
                                    placeholder="금액을 입력하세요"
                                    value={newTravelAllowance.amount}
                                    onChange={(e) =>
                                        setNewTravelAllowance((prev) => ({ ...prev, amount: e.target.value }))
                                    }
                                    required
                                />
                            </FormControl>

                            <Stack direction="row" spacing={1} justifyContent="flex-end">
                                <Button
                                    variant="outlined"
                                    type="button"
                                    onClick={() => setModalOpen(false)}
                                >
                                    취소
                                </Button>
                                <Button type="submit"
                                    loading={submitLoading}
                                    disabled={
                                        submitLoading
                                        || !newTravelAllowance.departureLocation
                                        || !newTravelAllowance.arrivalLocation
                                        || !newTravelAllowance.amount
                                    }
                                >
                                    전송
                                </Button>
                            </Stack>
                        </Stack>
                    </form>
                </ModalDialog>
            </Modal>

            {/* 출장비 금액 수정 모달 */}
            <Modal
                open={editModalOpen}
                onClose={() => {
                    setEditModalOpen(false);
                    setEditTargetId(null);
                    setEditValue("");
                }}
            >
                <ModalDialog>
                    <div style={{ width: "320px" }}>
                        <div style={{ fontSize: "18px", fontWeight: 600, marginBottom: "12px" }}>
                            {editTargetTitle}
                        </div>
                        <Input
                            type="number"
                            value={editValue}
                            onChange={(e: any) => setEditValue(e.target.value)}
                            placeholder="금액을 입력하세요"
                        />
                        <div style={{ marginTop: "28px" }}>
                            <Button
                                variant="solid"
                                fullWidth
                                onClick={submitEditTravelAllowance}
                                loading={editLoading}
                                disabled={!editValue}
                            >
                                수정하기
                            </Button>
                        </div>
                    </div>
                </ModalDialog>
            </Modal>
        </div>
    );
};

export default TravelAllowanceManagement;
